const RAW_BASE64_IMAGE_PATTERN = /^[a-z]+\/[a-z0-9.+-]+;base64,/i;

export const normalizeImageSource = (value: unknown): string => {
    const normalizedValue = String(value || '').trim();
    if (normalizedValue === '') {
        return '';
    }

    if (normalizedValue.startsWith('data:')) {
        return normalizedValue;
    }

    if (RAW_BASE64_IMAGE_PATTERN.test(normalizedValue)) {
        return `data:${normalizedValue}`;
    }

    return normalizedValue;
};

export default normalizeImageSource;
